import { useEffect, useState } from "react";
import { useLocation } from "../components/Router/state";
import { MaxBreakPoints } from "../style/constants";
import { useWindowSize } from "./useWindowSize";

const paths = [
  "/analytics",
  "/settings/account/whats-app",
  "/settings/account/social-templates",
  "/settings/account/template-manager",
  "/settings/account/team",
];

export const useIsMobile = () => {
  const { width } = useWindowSize();
  return width <= MaxBreakPoints.MEDIUM;
};

export const useDisplayMobileWall = () => {
  const isMobileWidth = useIsMobile();
  const path = useLocation().pathname;

  const [displayMobileWall, setDisplayMobileWall] = useState(false);

  useEffect(() => {
    setDisplayMobileWall(
      paths.some((endpoint) => path.startsWith(endpoint)) && isMobileWidth
    );
  }, [isMobileWidth, path]);

  return displayMobileWall;
};
